if (!customElements.get('blur-up')) {
  customElements.define(
    'blur-up',
    class BlurUp extends HTMLElement {
      connectedCallback() {
        const img = this.querySelector('img');
        if (!img || !this.classList.contains('blur-up--pending')) return;

        const reveal = () => this.classList.remove('blur-up--pending');

        img.addEventListener('load', reveal, { once: true });
        img.addEventListener('error', reveal, { once: true });

        if (img.complete) reveal();
      }
    }
  );
}
